export { default } from './RelatedRelations';
